import { c as _c } from "react/compiler-runtime";
import { Button, FullModal } from '@sbt-web/ui';
import styles from './index.module.scss';
export type ErrorDialogProps = {
  isOpened: boolean;
  onClose: () => void;
  onRetry: () => void;
  errors: string[];
};
export const ErrorDialog = t0 => {
  const $ = _c(7);
  const {
    isOpened,
    onRetry,
    onClose,
    errors
  } = t0;
  let t1;
  if ($[0] !== errors || $[1] !== onRetry) {
    t1 = errors.includes("REPLY:throttled") ? <div className={styles.body}><p className={`body-text book ${styles.description}`}>Al momento non possiamo recapitare il tuo messaggio: hai raggiunto il numero massimo di invii giornalieri.</p></div> : <div className={styles.body}><p className={`body-text book ${styles.description}`}>C'è stato un errore e non è stato possibile inviare il tuo messaggio. Ti invitiamo a riprovare.</p><div className={styles.buttonWrapper}><Button design="solid" onClick={onRetry}>Riprova</Button></div></div>;
    $[0] = errors;
    $[1] = onRetry;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isOpened || $[4] !== onClose || $[5] !== t1) {
    t2 = <FullModal title="Messaggio non inviato" open={isOpened} onClose={onClose} size="small">{t1}</FullModal>;
    $[3] = isOpened;
    $[4] = onClose;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};